export default __webpack_public_path__ + "static/media/olivier-photo.ff66be00.png";